/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useContext } from 'react';
import styled from 'styled-components';
import { Tabs, TabPane, Button } from 'components';
import { useHistory } from 'react-router-dom';
import { TabKey } from '../types';
import TeamContext from '../../../../contexts/TeamContext';

const PageTabs = () => {
  const {
    activeTab,
    setActiveTab,
    targetTeamState,
    selectedUsers,
    setSelectedUsers,
  } = useContext(TeamContext);

  const onTabPress = (key: TabKey) => {
    setActiveTab(key);
  };

  const teamMemberCount = targetTeamState.users.length;
  const teamMemberCountText = `${teamMemberCount} Member${
    teamMemberCount > 1 ? 's' : ''
  }`;
  const tabBarExtraContent =
    activeTab === 'MEMBERS' ? teamMemberCountText : undefined;

  const history = useHistory();
  const handleActivityClickBtn = () => {
    const query = selectedUsers.reduce((acc, user) => `${acc}${user},`, '');
    history.push(`/lockboxesActivities?userIds=${query}`);
  };

  return (
    <>
      <div style={{ display: 'flex', backgroundColor: 'white' }}>
        {activeTab === 'MEMBERS' && (
          <Button
            style={{ marginLeft: 'auto' }}
            disabled={!selectedUsers.length}
            onClick={handleActivityClickBtn}
          >
            View Activities
          </Button>
        )}
      </div>
      <StyledTabs
        activeKey={activeTab}
        onChange={onTabPress}
        tabBarExtraContent={tabBarExtraContent}
      >
        <TabPane tab="Details" key="DETAILS" data-cy="teamSettings-details" />
        <TabPane tab="Members" key="MEMBERS" data-cy="teamSettings-members" />
        <TabPane
          tab="Listing Settings"
          key="LISTING_SETTINGS"
          data-cy="teamSettings-listingSettings"
        />
      </StyledTabs>
    </>
  );
};

export default PageTabs;

const StyledTabs = styled(Tabs).attrs({
  tabBarStyle: { marginBottom: 0 },
})`
  padding: 0 24px;
  background: white;
`;
